<template>
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">{{'duplicates.possible_duplicates' | trans}}</h4>
            <div class="card-text">
              <div v-if="isLoading">{{'duplicates.load_possible_duplicates' | trans}}</div>
              <dl v-else-if="!isLoading && duplicates.length > 0">
                    <dd v-for="duplicate in duplicates" v-bind:key="duplicate.id">
                        <a :href="duplicate.url" target="_blank" v-bind:class="{ 'text-danger': duplicate.similarity >= 50, 'text-dark': duplicate.similarity < 50 }">
                            <div>{{duplicate.similarity.toFixed(2)}}%: {{duplicate.title}}</div>
                            <div class="text-small">{{duplicate.address}}</div>
                        </a>
                    </dd>
              </dl>
              <div v-else>{{'duplicates.no_duplicates_found' | trans}}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    duplicates: {
      type: Array,
      required: true,
    }
  }
};
</script>

